import { Anchor, Group } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { useDownload } from "../../../hooks/useDownload";
import urls from "../../../urls";
import type { Person } from "../../../utils/backend-types";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";
import { getDocumentName } from "../utils/getDocumentName";

function getInvoiceDocumentColumn(persons: Array<Person>): MRT_ColumnDef<Doc> {
  return {
    header: "Dokument",
    accessorKey: "id",
    accessorFn: (row) =>
      getDocumentName(
        persons,
        row.documentType,
        row.supplier,
        row.supplied,
        row.invoiceData
      ),
    enableSorting: false,
    size: 330,
    enableColumnFilter: false,
    Cell: ({ row, renderedCellValue }) => {
      const { download } = useDownload();

      return (
        <Group gap="xs" wrap="nowrap">
          <IconFileText size="1.2em" />
          {row.original.documentType === "draft" ? (
            renderedCellValue
          ) : (
            <Anchor
              component="button"
              type="button"
              variant="external"
              onClick={() =>
                download({
                  downloadUrl: urls.api.downloadInvoice(row.original.id)
                })
              }
            >
              {renderedCellValue}
            </Anchor>
          )}
        </Group>
      );
    }
  };
}

export { getInvoiceDocumentColumn };
